import { render } from "./ResearchItsCtaComp.vue?vue&type=template&id=42af0fcc&scoped=true"
import script from "./ResearchItsCtaComp.vue?vue&type=script&lang=js"
export * from "./ResearchItsCtaComp.vue?vue&type=script&lang=js"

import "./ResearchItsCtaComp.vue?vue&type=style&index=0&id=42af0fcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42af0fcc"]])

export default __exports__